import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../i18n/LanguageContext';
import LanguageSelector from '../../i18n/LanguageSelector';

const Footer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 0,
        mt: 'auto',
        backgroundColor: '#f5f5f5',
        borderTop: '1px solid #e0e0e0'
      }}
    >
      <Container maxWidth="none">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            {t('footer.copyright').replace('{year}', new Date().getFullYear())}
          </Typography>
          
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              mt: { xs: 2, md: 0 },
              flexWrap: 'wrap',
              justifyContent: { xs: 'center', md: 'flex-end' },
              alignItems: 'center'
            }}
          >
            <Link onClick={() => navigate('/homepage')} color="inherit" underline="hover" style={{cursor: 'pointer'}}>
              {t('footer.backToHomepage')}
            </Link>
            <Typography variant="body2" color="text.secondary" sx={{ display: { xs: 'none', md: 'inline' } }}>|</Typography>
            <Link onClick={() => navigate('/privacy-policy')} color="inherit" underline="hover" style={{cursor: 'pointer'}}>
              {t('footer.privacyPolicy')}
            </Link>
            <Typography variant="body2" color="text.secondary" sx={{ display: { xs: 'none', md: 'inline' } }}>|</Typography>
            <Link onClick={() => navigate('/termini-e-condizioni')} color="inherit" underline="hover" style={{cursor: 'pointer'}}>
              {t('footer.termsAndConditions')}
            </Link>
            <Typography variant="body2" color="text.secondary" sx={{ display: { xs: 'none', md: 'inline' } }}>|</Typography>
            <LanguageSelector />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;